import React, { useState} from 'react';
import dateformat from 'dateformat'
import { Card, Button } from 'react-bootstrap'

const Kvar = ({kvarovi, card, info}) => {

  const [showKvarove, setShowKvarove] = useState(false)

  return (
    <>
     <>
          <h6>Prikazi čitavu istoriju <span>{!showKvarove && <Button onClick={() => setShowKvarove(true)} variant='outline-success' size='md'>+</Button>}{showKvarove && <Button onClick={() => setShowKvarove(false)} variant='outline-success'>-</Button>}</span></h6>
        </>
        {kvarovi.length === 0 && info}
      {/* {kvarovi.length === 0 && info} */}
      {card && kvarovi.length !== 0 && kvarovi.filter((kv, index) => {
       if(showKvarove){
        return true
       } else {
         if(index===0){
           return true
         }else{
          return false
         }
         
       }
       
        
      }).map(kvar => (
     <div key={kvar._id}>   
    <Card border='primary' style={{ width: '18rem' }}>
    <Card.Body>
      <Card.Title>Informacije o kvaru</Card.Title>
      <Card.Text>
        <h6>Datum prijave kvara: </h6>
        <p>{dateformat(kvar.datum, 'd. mmmm yyyy.')}</p>
        <h6>Datum popravke: </h6>
        <p>{kvar.datumPopravke ? dateformat(kvar.datumPopravke, 'd. mmmm yyyy.') : '-'}</p>
        <h6>Email: </h6>
        <p>{kvar.email}</p>
        <h6>Kontakt telefon osobe: </h6>
        <p>{kvar.brojT}</p>
        <h6>Opis kvara: </h6>
        <p>{kvar.opisK}</p>
      </Card.Text>
    </Card.Body>
  </Card>
  <br/>
  </div>
  ))}
    </>
  )
}

export default Kvar
